module.exports = __webpack_public_path__ + "img/co-workers.56af3f5a.svg";